import React from 'react';
import { connect } from 'react-redux';

import { ButtonBase, Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import EditIcon from '@mui/icons-material/Edit';

import OntologyTree from '../../../common/OntologyTree';
import CommonStyles from '../../../common/CommonStyles';

import { jelTypes } from '../../../constants';
import JelsStyles from '../JelsStyles';

const styles = {
  ...CommonStyles,
  ...JelsStyles,
};

const RowChild = connect((state) => {
  return { jels: state.jels };
})(({ classes, toggleEditModal, toggleEditDashboardModal, node, jels }) => {
  let usingFrms = [];

  const id = +node.id;

  let dashboard = undefined;

  jels.dashboards.forEach((dashboardId) => {
    const dashboardData = jels.jelData[dashboardId];

    if (dashboardData.acc_concept === id) {
      dashboard = dashboardData;
    }
  });

  if (dashboard && dashboard.views)
    dashboard.views.forEach((view) => {
      const frm = jels.jelData[view.value];

      if (frm) usingFrms.push({ type: 'form', title: `${frm.id} ${frm.title}`, id: frm.id });
    });

  return [
    <div className={classes.mr20}>
      <Tooltip
        title="Edit"
        placement="top"
        onClick={() => {
          toggleEditDashboardModal({
            concept: node,
            isOpened: true,
            dashboard: dashboard,
            type: jelTypes.dashboard,
          });
        }}
        classes={{
          tooltip: classes.muiTooltip,
        }}
      >
        <EditIcon className={classes.tableRowBtn} />
      </Tooltip>
    </div>,
    <div key={id} className={classes.jelsContainer}>
      {usingFrms.map((jel, jelIndex) => {
        return (
          <Tooltip
            title="Form edit"
            key={jelIndex}
            placement="top"
            classes={{
              tooltip: classes.muiTooltip,
            }}
          >
            <ButtonBase
              className={`${classes.jelBtn}`}
              onClick={() => {
                if (jel.type === jelTypes.form) {
                  toggleEditModal({
                    isOpened: true,
                    data: jels.jelData[jel.id],
                    type: jel.type
                  });
                }
              }}
            >
              <img
                src="/images/ui-edit-frm.svg"
                alt="ui-edit-frm"
                style={{
                  width: '12px',
                  height: '12px',
                  marginRight: '12px',
                }}
              />

              <span className={classes.jelTitle}>{jel.title}</span>
            </ButtonBase>
          </Tooltip>
        );
      })}
    </div>
  ];
});

export default connect((state) => ({
  jels: state.jels,
  accounts_tbox: state.meta.accounts_tbox
}))(
  withStyles(styles)((props) => {
    const { accounts_tbox, classes, jels, toggleEditModal, toggleEditDashboardModal } = props;

    const dashboardIdsByAccConcept = {}, accConceptIds = [];
    if (jels.dashboards) {
      for (const dashboardId of jels.dashboards) {
        const dashboard = jels.jelData[dashboardId];
        if (dashboard && dashboard.acc_concept)
          accConceptIds.push(+dashboard.acc_concept);
      }
      for (const dashboardId of jels.dashboards) {
        const dashboard = jels.jelData[dashboardId];
        if (dashboard && dashboard.acc_concept) {
          /*prevent the case when multiple dashboards have the same concept*/
          if (accConceptIds.filter(cid => cid === dashboard.acc_concept).length > 1) continue;
          dashboardIdsByAccConcept[dashboard.acc_concept] = dashboardId;
        }
      }
    }

    return (
      <div>
        <div
          className={`${classes.alignCenter}`}
          style={{
            paddingTop: '8px',
            paddingLeft: '30px',
            paddingBottom: '7px',
          }}
        >
          <div
            style={{
              width: '37px',
            }}
          >
            <span className={classes.columnHeadingGeneral}>ID</span>
          </div>

          <div
            style={{ width: '250px' }}
          >
            <span className={classes.columnHeadingGeneral}>Account group</span>
          </div>

          <div>
            <span className={classes.columnHeadingGeneral}>Uses</span>
          </div>
        </div>

        <div style={{ backgroundColor: '#fff', marginBottom: '50px' }}>
          <OntologyTree
            hideCheckboxes
            dashboardIdsByAccConcept={dashboardIdsByAccConcept}
            ancestorIds={accounts_tbox.implemented_cids}
            nodes={accounts_tbox.nodes}
            styles={{
              row: {
                borderBottom: '1px solid rgba(224, 224, 224, 1)',
              },
              switcher: {
                display: 'none',
              },
              parentLine: { display: 'none' },
            }}
          >
            <RowChild
              classes={classes}
              toggleEditModal={toggleEditModal}
              toggleEditDashboardModal={toggleEditDashboardModal}
            />
          </OntologyTree>
        </div>

      </div>
    );
  })
);
